import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Offcanvas,
  Modal,
  Nav,
  Navbar,
  Dropdown,
} from "react-bootstrap";
import { logoutUser } from "../redux/auth/actions";
import { CasinoProviders } from "../lib/data";
import { getUserBet } from "../redux/sports/actions";
import logo from "../assets/images/logo.webp";
import ToggleIcon from "../assets/images/icons/toggle-icon.png";
import TelegramIcon from "../assets/svg/TelegramIcon";
import WhatsappIcon from "../assets/svg/WhatsappIcon";
import numberWithCommas from "../utils/numbersWithComma";
import Profile from "../assets/images/icons/user-profile-wht.png";
import MyBets from "../assets/images/icons/my-bets-wht.png";
import Bonus from "../assets/images/icons/bonus-wht.png";
import Referral from "../assets/images/icons/referral-wht.png";
import Statement from "../assets/images/icons/statement-wht.png";
import SPMGames from "../assets/images/icons/spm-games.png";
import Logout from "../assets/images/icons/signout-wht.png";
import Sports from "../assets/images/games-icon/headicon/sports.png";
import Exchange from "../assets/images/games-icon/headicon/exchange.png";
import Sportsbook from "../assets/images/games-icon/headicon/sportsbook.png";
import Evolution from "../assets/images/games-icon/headicon/evolution.png";
import Ezugi from "../assets/images/games-icon/headicon/ezugi.png";
import Slots from "../assets/images/games-icon/headicon/slots.png";
import Kingmaker from "../assets/images/games-icon/headicon/kingmaker.png";
import Aviator from "../assets/images/games-icon/Aviator.png";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import { VscVerifiedFilled } from "react-icons/vsc";
import { handleRightSideBar } from "../redux/app/actions";
import DepositMob from "../assets/images/icons/wallet.png";
import WithdrawMob from "../assets/images/icons/withdraw-icon.png";
import ProfileIcon from "../assets/images/icons/man.png";
import BetsIcon from "../assets/images/icons/bet.png";
import AccountStatementICon from "../assets/images/icons/account-statement.png";
import BonusIcon from "../assets/images/icons/bonus.png";
import ReferralICon from "../assets/images/icons/users.png";
import Logout1 from "../assets/images/icons/log-out.png";
import WhatsappIconNew from "../assets/images/social/whatsapp.png";

const HeaderAfterLogin = () => {
  const { user, wallet, exposureAmount } = useSelector((state) => state.auth);
  const { betMatches, userBets } = useSelector((state) => state.sports);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [showBetModal, setShowBetModal] = useState(false);
  const [showUserBetModal, setShowUserBetModal] = useState(false);
  const [showLeftbarToggle, setShowLeftbarToggle] = useState(false);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const htmlElement = document.documentElement;
  const { showRightSideBar } = useSelector((state) => state.app);
  const handleClose = () => {
    handleSideBarVisibility(false);
    setShow(false);
  };
  const handleSideBarVisibility = (value) => {
    dispatch(handleRightSideBar(value));
  };
  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  useEffect(() => {
    if (showLeftbarToggle) {
      htmlElement.style.overflow = "hidden";
      document.body.classList.add("leftbat-opened");
    } else {
      htmlElement.style.overflow = "auto";
      document.body.classList.remove("leftbat-opened");
    }
  }, [showLeftbarToggle]);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const handleRowClick = (item) => {
    dispatch(
      getUserBet({
        skip: 0,
        pageSize: 10,
        refmatchid: item?.refMatchId,
      })
    );
    setShowBetModal(false);
    setShowUserBetModal(true);
  };

  const handleToggleClick = () => {
    const realTimeValue = !showLeftbarToggle;
    if (realTimeValue) {
      htmlElement.style.overflow = "hidden";
      document.body.classList.add("leftbat-opened");
    } else {
      htmlElement.style.overflow = "auto";
      document.body.classList.remove("leftbat-opened");
    }
    setShowLeftbarToggle(realTimeValue);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const offcanvas = document.querySelector(".offcanvas");

      if (showRightSideBar && offcanvas && !offcanvas.contains(event.target)) {
        handleClose();
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [showRightSideBar]);

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu top-head">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}
      <header className="header aftrlgn">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div className="leftbar_toggle d-none">
                    <Button
                      variant="primary"
                      // onClick={() => setShowLeftbarToggle((s) => !s)}
                      onClick={() => handleToggleClick()}
                    >
                      <img src={ToggleIcon} />
                    </Button>
                  </div>
                  <div className="logo">
                    <a href="/home">
                      {/* <img src={appDetails?.LOGO_URL} alt="Logo" /> */}
                      <img src={logo} alt="Logo" />
                    </a>
                  </div>
                  <div className="d-none">
                    <GamesSearchModal />
                  </div>
                </div>

                <div className="headerRight">
                  {/* <a href="/deposit" className="deposit primary">
                  Deposit
                </a> */}

                  <Dropdown align="end" className="me-2">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      Bal: <span>{numberWithCommas(wallet?.cash || 0)}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="tel:{user?.mobileno}">
                        <b>{user?.mobileno}</b>
                      </Dropdown.Item>
                      <Dropdown.Item href="#">
                        <h6>Balance</h6>
                        <span>
                          INR {numberWithCommas(wallet?.balance || 0)}
                        </span>
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => setShowBetModal(true)}
                      >
                        <h6>Cash</h6>
                        <span>INR {numberWithCommas(wallet?.cash || 0)}</span>
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => setShowBetModal(true)}
                      >
                        <h6>Exposure</h6>
                        <span>INR {numberWithCommas(exposureAmount || 0)}</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="/bonus">
                        <h6>Bonus</h6>
                        <span>INR {numberWithCommas(wallet?.coins)}</span>
                      </Dropdown.Item>
                      <Dropdown.Item href="/gatewaylist" className="deposit">
                        Deposit
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <div className="funds me-2">
                    <ul>
                      <li className="">
                        <a href="/gatewaylist" className="deposit">
                          Deposit
                        </a>
                      </li>
                    </ul>
                  </div>
                  <Button
                    variant="primary menu-btn"
                    onClick={() => {
                      dispatch(handleRightSideBar(!showRightSideBar));
                    }}
                    className=""
                  >
                    <img
                      src={Profile}
                      alt="my menu"
                      style={{ width: "18px" }}
                    />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bottom_head d-none ">
          <Navbar expand="md" className="">
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              // onClick={() => setShowToggle((s) => !s)}
            />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav>
                <Nav.Link href="/home" className="logoImg d-md-none">
                  <img src={appDetails?.LOGO_URL} alt="Logo" />
                </Nav.Link>
                <Nav.Link href="/spmsports/cricket">
                  <img src={Sports} />
                  Sports
                </Nav.Link>
                <Nav.Link href="/Exchange/cricket">
                  <img src={Exchange} />
                  Exchange
                </Nav.Link>
                <Nav.Link href="/betby" className="">
                  <img src={Sportsbook} />
                  Sportsbook
                </Nav.Link>
                <Nav.Link href="/sportsbook2" className="">
                  <img src={Sportsbook} />
                  Sportsbook 2
                </Nav.Link>
                <Nav.Link href={CasinoProviders["evolution"]?.href}>
                  <img src={Evolution} />
                  Evolution
                </Nav.Link>
                <Nav.Link href={CasinoProviders["ezugi"]?.href}>
                  <img src={Ezugi} />
                  Ezugi
                </Nav.Link>
                <Nav.Link href="/slots">
                  <img src={Slots} />
                  Slots
                </Nav.Link>
                <Nav.Link href="/kingmaker">
                  <img src={Kingmaker} />
                  Kingmaker
                </Nav.Link>
                <Nav.Link href="/casino/spribe/aviator">
                  <img src={Aviator} />
                  Aviaitor
                </Nav.Link>
                {/* <Nav.Link href="/casino/xpg">
                  <img src={XPGNew} />
                  XPG
                </Nav.Link>
                <Nav.Link href="/casino/vivo">
                  <img src={VivoNew} />
                  Vivo
                </Nav.Link>
                <Nav.Link href="/casino/qtech">
                  <img src={QtechNew} />
                  Qtech
                </Nav.Link>
                <Nav.Link href="/casino/worldcasino">
                  <img src={OnetouchNew} />
                  OneTouch
                </Nav.Link>
                <Nav.Link href="/casino/pragmaticplay">
                  <img src={ParagmaticplayNew} />
                  Pragmaticplay
                </Nav.Link>
                <Nav.Link href="/casino/onlyplay">
                  <img src={onlyplayNew} />
                  Onlyplay
                </Nav.Link> */}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>

        <Offcanvas
          show={showRightSideBar}
          onHide={handleClose}
          placement={"end"}
          className="Loginpage AfterLoginBox"
        >
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex Profile">
                <div className="profile-img">
                  <img src={Profile} alt="profile" style={{ width: "24px" }} />
                </div>
                <div className="user-info">
                  <span>{user?.mstruserid}</span>
                  {/* <a href="tel:{user?.mobileno}">{user?.mobileno}</a> */}
                  <a>{user?.mobileno}</a>
                </div>
              </div>
              <div className="top_sec">
                <div className="row">
                  <div className="col-6">
                    <div className="balance mb-1">Main Balance</div>
                  </div>
                  <div className="col-6">
                    <div className="balance-amount mb-1">
                      {numberWithCommas(wallet?.cash || 0)}
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="balance mb-3">Bonus</div>
                  </div>
                  <div className="col-6">
                    <div className="balance-amount mb-3">
                      {numberWithCommas(wallet?.coins) || 0}
                    </div>
                  </div>
                  <div
                    className="col-6 d-md-block d-none"
                    onClick={() => {
                      window.location.href = "/withdraw";
                    }}
                  >
                    <Button variant="  w-100" className="btn-secondary">
                      Withdraw
                    </Button>
                  </div>
                  <div
                    className="col-6 d-md-block d-none"
                    onClick={() => {
                      window.location.href = "/gatewaylist";
                    }}
                  >
                    <Button variant="primary dpst-btn w-100">Deposit</Button>
                  </div>

                  <div className="d-flex MobDepositBox d-md-none">
                    <ul>
                      <li>
                        <a href="/gatewaylist">
                          <img src={DepositMob} alt="" />
                          <span>Deposit</span>
                        </a>
                      </li>
                      <li>
                        <a href="/withdraw">
                          <img src={WithdrawMob} alt="" />
                          <span>Withdraw</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="MobSectionMenu d-block d-md-block">
              <ul>
                <li>
                  <a href="/profile">
                    <img src={ProfileIcon} alt="ProfileIcon" />
                    <div>
                      <h2>Profile</h2>
                      <p>My Profile</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/my-bets">
                    <img src={BetsIcon} alt="ProfileIcon" />
                    <div>
                      <h2>My Bets</h2>
                      <p>My bets</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/cashier">
                    <img src={AccountStatementICon} alt="ProfileIcon" />
                    <div>
                      <h2>Transaction</h2>
                      <p>My transaction history</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/bonus">
                    <img src={BonusIcon} alt="ProfileIcon" />
                    <div>
                      <h2>Bonus</h2>
                      <p>My bonus</p>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/referral">
                    <img src={ReferralICon} alt="ProfileIcon" />
                    <div>
                      <h2>Referral</h2>
                      <p>My referral</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <ul className="menu-items d-md-none d-none">
              <li>
                <a href="/profile">
                  <img src={Profile} alt="profile" />
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <img src={MyBets} alt="my bets" />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/bonus">
                  <img src={Bonus} alt="bonus" />
                  <span>Bonus</span>
                </a>
              </li>
              <li>
                <a href="/referral">
                  <img src={Referral} alt="referral" />

                  <span>Referral</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img src={Statement} alt="account statement" />
                  <span>Account Statement</span>
                </a>
              </li>
              {/* <li>
              <a href="#">
                <SettingIcon />
                <span>Transfer Funds ( For Excahnge)</span>
              </a>
            </li> */}
              {/* <li>
              <a href="/settings">
                <SettingIcon />
                <span>Settings</span>
              </a>
            </li> */}

              <li onClick={() => dispatch(logoutUser())}>
                <a href="/">
                  <img src={Logout} alt="logout" />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>

            <div className="d-md-block d-block">
              <ul className="LogoutMob">
                <li onClick={() => dispatch(logoutUser())}>
                  <a href="/">
                    <img src={Logout1} alt="logout" />
                    <span>Sign Out</span>
                  </a>
                </li>
              </ul>
            </div>
            <ul className="social_links">
              <li>
                <a target="_blank" href={`${appDetails?.TELEGRAM}`}>
                  <TelegramIcon />
                </a>
              </li>
              {/* <li>
              <div
                onClick={() =>
                  window.open(https://wa.me/+917888846060, "_blank")
                }
              >
                <WhatsappIcon />
              </div>
            </li> */}
            </ul>
          </Offcanvas.Body>
        </Offcanvas>

        <Modal
          className="betslip_popup outer_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Exposure amount</th>
                      <th scope="col">Match name</th>
                      <th scope="col">Ref match ID</th>
                      <th scope="col">Total bets</th>
                    </tr>
                  </thead>
                  <tbody>
                    {betMatches &&
                      betMatches.length &&
                      betMatches.map((item, index) => {
                        return (
                          <tr
                            onClick={() => {
                              handleRowClick(item);
                            }}
                          >
                            <th scope="row">{index + 1}</th>
                            <td>{item?.exposureAmount}</td>
                            <td>{item?.matchName}</td>
                            <td>{item?.refMatchId}</td>
                            <td>{item?.totalBets}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="betslip_popup inner_popup"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUserBetModal}
        >
          <Modal.Body>
            {" "}
            <main className="main">
              <div className="container table-responsive">
                <table className="table text-white">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Odds</th>
                      <th scope="col">Stack</th>
                      <th scope="col">Selection type</th>
                      <th scope="col">Status</th>
                      <th scope="col">Create date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userBets &&
                      userBets.length &&
                      userBets.map((item, index) => {
                        return (
                          <tr>
                            <th scope="row">{index + 1}</th>
                            <td>{item?.odds}</td>
                            <td>{item?.stack}</td>
                            <td>{item?.selectionType}</td>
                            <td>{item?.status}</td>
                            <td>{item?.createdAt}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </main>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowUserBetModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </header>
    </>
  );
};

export default HeaderAfterLogin;
